package br.com.texeratx.boardgametimeapp.data.model.game

import kotlinx.serialization.Serializable

@Serializable
data class CatalogGameDTO(
    val id: Long,
    val name: String,
    val imageUrl: String? = null,
    val minNumberOfPlayers: Int? = null,
    val maxNumberOfPlayers: Int? = null,
    val bggUrl: String? = null,
    val gameDuration: Int? = null,
    val gameCategoryId: Long? = null,
    val categoryName: String? = null,
    val status: Int = 1,
    val bggId: Long? = null,
    val yearPublished: Int? = null,
    val thumbnailUrl: String? = null,
    val bggRank: Int? = null,
    val ratingAverage: Double? = null,
    val complexityAverage: Double? = null
)
